import { useContext, useState, useEffect } from "react";
import Configure from "./Configure";
import Axios from "axios";
import { useData } from "@microsoft/teamsfx-react";
import { TeamsFxContext } from "./Context";
import InfinityOne from "./InfinityOne";
import SideBar from "./SideBar";
import DialPad from "./Dialpad/index";
import { useNavigate } from "react-router-dom";

const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL;
const BACKEND_API_TOKEN = process.env.REACT_APP_BACKEND_API_TOKEN;

const validateaccount = async (
  emailaddress,
  backendapiurl,
  backendapitoken
) => {
  const params = JSON.stringify({
    action: "validate",
    emailaddress: emailaddress,
  });
  const headerconfig = {
    headers: {
      "Content-Type": "application/json",
      authorization: backendapitoken,
    },
  };

  const response = await Axios.post(backendapiurl, params, headerconfig);
  return response;
};

const Main = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dialersubscribed, setDialersubscribed] = useState("");
  const [frameUrl, setFrameUrl] = useState("");
  const [profileMail, setProfileMail] = useState("");
  const { teamsUserCredential } = useContext(TeamsFxContext);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [teamsToken, setTeamsToken] = useState<any>(null);
  const [messg, setMessg] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  const className =
    windowWidth <= 768
      ? "col-12 pe-0 collapse"
      : "col-12 col-md-3 col-lg-3 col-xl-2 col-xxl-2 pe-0 ps-0";

  const { loading, data, error, reload } = useData(async () => {
    console.log(teamsUserCredential);
    if (!teamsUserCredential) {
      console.log("No Teams User Credential found");
      return;
    }
    if (teamsUserCredential) {
      try {
        const userInfo = await teamsUserCredential.getUserInfo();
        fetchSubscriptionStatus(userInfo.preferredUserName);
        setProfileMail(userInfo.preferredUserName);
        return userInfo;
      } catch (err: any) {
        if (
          err.code === "UiRequiredError" ||
          err.message.includes("login_required") ||
          err.code === "invalid_grant" ||
          err.message.includes("consent_required")
        ) {
          setMessg("UI interaction required, prompting login...");
          // This might trigger a popup or redirect for the user to log in
          await teamsUserCredential.login(["access_as_user"]); // Or the specific scopes you need
          setMessg("err?.message");
          const tokenResult = await teamsUserCredential.getToken(
            "https://graph.microsoft.com"
          );
          if (tokenResult) {
            setTeamsToken(tokenResult); // tokenResult is of type AccessToken
          } else {
            console.warn("Failed to get token: tokenResult is null");
            setTeamsToken(""); // or handle it some other way, like showing an error
          }
          // After successful login, try getting user info again
          const userInfo = await teamsUserCredential.getUserInfo();
          fetchSubscriptionStatus(userInfo.preferredUserName);
          setProfileMail(userInfo.preferredUserName);
          return userInfo;
        }
        setMessg(err?.message);
        console.error("Error getting user info:", err);
        throw err; // Re-throw if it's another type of error
      }
    }
  });

  const userName = loading || error ? "" : data!.displayName;

  const fetchSubscriptionStatus = (email) => {
    if (email !== undefined) {
      if (email != "Null") {
        const subscribed = validateaccount(
          email,
          BACKEND_API_URL,
          BACKEND_API_TOKEN
        );
        subscribed.then(function (result) {
          const res = JSON.parse(result.data.message);
          if (res.status == "Success") {
            setDialersubscribed("Valid");
            setFrameUrl(res.frameurl);
          } else {
            setDialersubscribed("InValid");
          }
          setIsLoading(false);
        });
      }
    }
  };

  const [timeOut, setTimeOut] = useState(false);

  const HandleSubscription = (status) => {
    setDialersubscribed(status);
    if (timeOut == false) {
      setTimeOut(true);
      const timeId = setTimeout(() => {
        // After 3 seconds set the show value to false
        setTimeOut(false);
      }, 3000);
    }
  };

  return (
    <>
      {loading && (
        <div className="contact_bg loader">
          <div className="spinner"></div>
        </div>
      )}
      {messg}
      {!loading && !data && (
        <div className="content_bg">
          <div className="w-100 h-100 text-center pt-5 pb-5">
            <button className="mt-20 btn submit-btn reload" onClick={reload}>
              SignIn With Microsoft
            </button>
          </div>
        </div>
      )}
      {!loading && data && (
        <>
          {isLoading ? (
            <div className="contact_bg loader">
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="contact_bg">
              {dialersubscribed === "Valid" ? (
                <>
                  <div className="d-block d-md-none pt-3">
                    <DialPad userEmail={profileMail} />
                  </div>
                  <div className="d-none d-md-block">
                    <div className="row p-0 m-0">
                      {windowWidth <= 768 && (
                        <div className="col-12">
                          <button
                            className="btn btn-success btn-viewrecent w-100 rounded-0"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseContainer"
                            aria-expanded="false"
                            aria-controls="collapseContainer"
                          >
                            View Contacts
                          </button>
                        </div>
                      )}
                      <div className={className} id="collapseContainer">
                        <SideBar accountemail={profileMail} />
                      </div>
                      <div className="col-12 col-md-9 col-lg-9 col-xl-10 col-xxl-10 ps-0">
                        <InfinityOne frameUrl={frameUrl} />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}

              {dialersubscribed === "InValid" ? (
                <>
                  <Configure
                    onSubscription={HandleSubscription}
                    userEmail={profileMail}
                  />
                </>
              ) : (
                <></>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Main;
